import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { CaviarCard } from '../components/CaviarCard'

export default function Caviar(){
  const { t } = useTranslation()

  const caviarTypes = [
    {
      name: t('caviar.products.oscietre.name'),
      description: t('caviar.products.oscietre.desc'),
      image: '/images/caviar-removebg-preview.png',
      specs: {
        color: t('caviar.products.oscietre.color'),
        size: t('caviar.products.oscietre.size'),
        taste: t('caviar.products.oscietre.taste')
      }
    },
    {
      name: t('caviar.products.baeri.name'),
      description: t('caviar.products.baeri.desc'),
      image: '/images/caviar-removebg-preview.png',
      specs: {
        color: t('caviar.products.baeri.color'),
        size: t('caviar.products.baeri.size'),
        taste: t('caviar.products.baeri.taste')
      }
    },
    {
      name: t('caviar.products.siberian.name'),
      description: t('caviar.products.siberian.desc'),
      image: '/images/caviar-removebg-preview.png',
      specs: {
        color: t('caviar.products.siberian.color'),
        size: t('caviar.products.siberian.size'),
        taste: t('caviar.products.siberian.taste')
      }
    }
  ]

  return (
    <main>
      <Helmet><title>{t('caviar.title')} — Pearl of Galia</title></Helmet>

      {/* HERO */}
      <section className="hero">
        <img src="/images/logo-removebg-preview (1).png" alt="Pearl of Galia logo" className="brand-logo-hero" />
        <div className="brand">
          <h1>
            <span>RARE</span><br/>
            <span>CAVIAR</span>
          </h1>
          <p className="tagline">EXCEPTIONAL SELECTIONS</p>
        </div>
      </section>

      {/* CAVIAR INTRO */}
      <section className="room">
        <div className="grid">
          <div>
            <img src="/images/caviar-removebg-preview.png" alt="Premium caviar presentation" />
          </div>
          <div>
            <h2 className="section-title">CURATED SELECTIONS</h2>
            <p><strong>Precise salting and maturation for uncompromising quality.</strong></p>
            <p>Our caviar comes from sustainable aquaculture, carefully selected for size consistency, firmness, and flavor profile. Each batch undergoes traditional Malossol preparation with minimal salt to preserve the natural characteristics.</p>

            <p className="label">ORIGIN</p>
            <p>France & Madagascar sustainable farms</p>

            <p className="label">SPECIES</p>
            <p>Oscietre, Baeri, Siberian</p>

            <p className="label">PREPARATION</p>
            <p>Traditional Malossol (low salt)</p>

            <p className="label">STORAGE</p>
            <p>-2°C to +2°C, cold-chain integrity</p>
          </div>
        </div>
      </section>

      {/* CAVIAR TYPES */}
      <section className="room">
        <h2 className="section-title">OUR CAVIAR SELECTION</h2>
        <div className="product-grid">
          {caviarTypes.map((caviar, index) => (
            <CaviarCard
              key={index}
              name={caviar.name}
              description={caviar.description}
              image={caviar.image}
              specs={caviar.specs}
            />
          ))}
        </div>
      </section>

      {/* SERVICE SECTION */}
      <section className="room">
        <div className="grid">
          <div>
            <h2 className="section-title">SERVICE & DELIVERY</h2>
            <p><strong>Professional cold-chain logistics for pristine quality.</strong></p>

            <p className="label">B2B SERVICE</p>
            <p>Dedicated account management for restaurants, hotels, and culinary professionals. Custom packaging and delivery schedules.</p>

            <p className="label">COLD-CHAIN</p>
            <p>Temperature-controlled transport from facility to your door. Real-time monitoring and quality guarantees.</p>

            <p className="label">DELIVERY</p>
            <p>Next-day delivery across EU. Global shipping for special orders. Insulated packaging with gel packs.</p>

            <p className="label">MINIMUM ORDERS</p>
            <p>30g minimum for restaurants<br/>
            50g minimum for private clients</p>
          </div>
          <div>
            <img src="/images/distribution_1-removebg-preview.png" alt="Professional delivery service" />
          </div>
        </div>
      </section>

      {/* TASTING SECTION */}
      <section className="room">
        <div className="grid">
          <div>
            <img src="/images/tasting-removebg-preview.png" alt="Private caviar tasting" />
          </div>
          <div>
            <h2 className="section-title">PRIVATE TASTINGS</h2>
            <p><strong>Curated tasting experiences for connoisseurs.</strong></p>

            <p>We offer exclusive tasting sessions for clients seeking to explore our full range. Each session includes multiple varieties, proper service instruction, and pairing recommendations.</p>

            <p className="label">INCLUDED</p>
            <p>• Selection of 3-5 caviar varieties<br/>
            • Traditional service accessories<br/>
            • Expert guidance and education<br/>
            • Pairing suggestions</p>

            <p className="label">BOOKING</p>
            <p>Contact us to arrange private tastings in Paris or select European cities. Minimum 48-hour advance notice required.</p>

            <Link to="/contact#contact-form" className="btn">{t('cta.book')} Tasting</Link>
          </div>
        </div>
      </section>
    </main>
  )
}

